<template>
  <HeaderMenuSection ref="headerMenu"></HeaderMenuSection>
</template>

<script>
  import HeaderMenuSection from "./HeaderMenuSection.vue";
  import BeforeRouteEnter from "./BeforeRouteEnter.js";

  export default {
    name: "HeaderMenuWrapper",
    components: {
      HeaderMenuSection,
    },
    beforeRouteEnter: BeforeRouteEnter,
  };
</script>
